import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.survey.take');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare const WizRoute: any;

@Component({
    selector: 'wiz-page-survey-take',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.survey.take/view.scss */
:host {
  display: block;
  width: 100%;
  min-height: 100%;
}

.survey-experience {
  position: relative;
  min-height: 100vh;
  overflow: hidden;
  background: radial-gradient(circle at 0% 0%, rgba(165, 196, 255, 0.55), transparent 28%), radial-gradient(circle at 100% 12%, rgba(158, 233, 214, 0.36), transparent 24%), linear-gradient(180deg, #eef5ff 0%, #f8fbff 48%, #f7f8fc 100%);
  font-family: "SUIT", "Pretendard", "Apple SD Gothic Neo", "Noto Sans KR", sans-serif;
}

.survey-experience__glow {
  position: absolute;
  border-radius: 999px;
  filter: blur(16px);
  opacity: 0.8;
  pointer-events: none;
}

.survey-experience__glow--one {
  top: 6rem;
  left: -4rem;
  width: 14rem;
  height: 14rem;
  background: rgba(99, 102, 241, 0.12);
  animation: surveyFloat 11s ease-in-out infinite;
}

.survey-experience__glow--two {
  right: -3rem;
  top: 18rem;
  width: 16rem;
  height: 16rem;
  background: rgba(16, 185, 129, 0.1);
  animation: surveyFloat 14s ease-in-out infinite reverse;
}

.survey-submit-overlay {
  position: fixed;
  inset: 0;
  z-index: 40;
  display: grid;
  place-items: center;
  padding: 1.5rem;
}

.survey-submit-overlay__backdrop {
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at top, rgba(99, 102, 241, 0.2), transparent 32%), rgba(241, 245, 249, 0.86);
  backdrop-filter: blur(10px);
}

.survey-submit-overlay__card {
  position: relative;
  z-index: 1;
  width: min(100%, 27rem);
  padding: 2rem 1.5rem;
  border-radius: 2rem;
  text-align: center;
  border: 1px solid rgba(255, 255, 255, 0.72);
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(18px);
  box-shadow: 0 28px 60px rgba(30, 41, 59, 0.1);
  animation: surveyRise 0.36s ease-out both;
}

.survey-spinner--submit {
  width: 3rem;
  height: 3rem;
  margin-bottom: 1rem;
}

.survey-submit-overlay__title {
  margin: 0.7rem 0 0;
  color: #172554;
  font-size: 1.32rem;
  line-height: 1.45;
  font-weight: 800;
}

.survey-submit-overlay__desc {
  margin: 0.7rem 0 0;
  color: #64748b;
  font-size: 0.92rem;
  line-height: 1.68;
}

.survey-experience__inner {
  position: relative;
  z-index: 1;
  max-width: 72rem;
  margin: 0 auto;
  padding: 1.25rem 1rem 1.5rem;
}

.survey-state-card,
.survey-panel,
.survey-actionbar {
  border: 1px solid rgba(255, 255, 255, 0.72);
  background: rgba(255, 255, 255, 0.82);
  backdrop-filter: blur(18px);
  box-shadow: 0 28px 60px rgba(30, 41, 59, 0.08);
}

.survey-state-card {
  max-width: 42rem;
  margin: 3rem auto 0;
  padding: 2rem 1.5rem;
  border-radius: 2rem;
  text-align: center;
  animation: surveyRise 0.5s ease-out both;
}

.survey-state-card--error {
  border-color: rgba(251, 113, 133, 0.25);
  background: rgba(255, 241, 242, 0.92);
}

.survey-state-card--verify {
  max-width: 30rem;
  text-align: left;
}

.survey-state-card__eyebrow {
  color: #6366f1;
  font-size: 0.76rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.survey-state-card__title {
  margin: 0.65rem 0 0;
  color: #172554;
  font-size: 1.4rem;
  line-height: 1.4;
  font-weight: 800;
}

.survey-state-card__desc {
  margin: 0.7rem 0 0;
  color: #64748b;
  font-size: 0.95rem;
  line-height: 1.7;
}

.survey-spinner {
  width: 2.6rem;
  height: 2.6rem;
  margin: 0 auto 0.9rem;
  border-radius: 999px;
  border: 3px solid rgba(99, 102, 241, 0.16);
  border-top-color: #6366f1;
  animation: surveySpin 0.9s linear infinite;
}

.survey-verify {
  display: grid;
  gap: 0.8rem;
  margin-top: 1.25rem;
}

.survey-verify__input {
  width: 100%;
  border-radius: 1rem;
  border: 1px solid rgba(191, 208, 255, 0.85);
  background: rgba(255, 255, 255, 0.98);
  color: #0f172a;
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  padding: 0.95rem 1rem;
  outline: none;
  transition: border-color 180ms ease, box-shadow 180ms ease;
}

.survey-verify__input:focus {
  border-color: rgba(79, 70, 229, 0.56);
  box-shadow: 0 0 0 4px rgba(79, 70, 229, 0.1);
}

.survey-verify__button {
  appearance: none;
  border: 0;
  border-radius: 1rem;
  padding: 0.95rem 1rem;
  background: linear-gradient(135deg, #5b6cfb 0%, #4f46e5 100%);
  color: #fff;
  font-size: 0.95rem;
  font-weight: 800;
  box-shadow: 0 18px 34px rgba(79, 70, 229, 0.24);
}

.survey-verify__button:disabled {
  opacity: 0.55;
}

.survey-verify__hint {
  margin: 0;
  color: #64748b;
  font-size: 0.84rem;
  line-height: 1.55;
}

.survey-verify__error {
  margin: 0;
  color: #e11d48;
  font-size: 0.84rem;
  font-weight: 700;
  line-height: 1.5;
}

.survey-layout {
  display: grid;
  gap: 1rem;
  grid-template-columns: minmax(0, 1fr);
}

.survey-main {
  min-width: 0;
}

.survey-panel {
  border-radius: 2rem;
  padding: 1.15rem;
  animation: surveyRise 0.55s ease-out both;
}

.survey-panel + .survey-panel {
  margin-top: 0.95rem;
}

.survey-panel__eyebrow,
.survey-panel__subeyebrow,
.survey-currenthead__eyebrow {
  color: #6366f1;
  font-size: 0.76rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.survey-panel__title {
  margin: 0.55rem 0 0;
  color: #0f172a;
  font-size: 1.45rem;
  line-height: 1.38;
  font-weight: 800;
}

.survey-panel__desc,
.survey-panel__subcopy,
.survey-currenthead__guide {
  margin: 0.7rem 0 0;
  color: #64748b;
  font-size: 0.92rem;
  line-height: 1.68;
}

.survey-identity {
  margin-top: 0.9rem;
  padding: 0.95rem 1rem;
  border-radius: 1.3rem;
  background: linear-gradient(180deg, rgba(238, 242, 255, 0.92) 0%, rgba(255, 255, 255, 0.86) 100%);
}

.survey-identity__label,
.survey-hero-stat span,
.survey-currentstat span,
.survey-progress__meta span,
.survey-sectionchip__meta {
  color: #64748b;
  font-size: 0.78rem;
  font-weight: 700;
}

.survey-identity__value {
  margin-top: 0.28rem;
  color: #172554;
  font-size: 1.55rem;
  font-weight: 800;
  letter-spacing: -0.02em;
}

.survey-progress {
  margin-top: 1rem;
}

.survey-progress__meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}

.survey-progress__meta strong {
  color: #312e81;
  font-size: 0.9rem;
  font-weight: 800;
}

.survey-progress__track {
  margin-top: 0.5rem;
  height: 0.7rem;
  border-radius: 999px;
  overflow: hidden;
  background: rgba(226, 232, 240, 0.72);
}

.survey-progress__fill {
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #6366f1 0%, #4f46e5 52%, #22c55e 100%);
  box-shadow: 0 0 20px rgba(79, 70, 229, 0.26);
  transition: width 240ms ease;
}

.survey-currentstats {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.75rem;
  margin-top: 1rem;
}

.survey-currentstat {
  padding: 0.85rem 0.9rem;
  border-radius: 1.2rem;
  background: rgba(255, 255, 255, 0.74);
  border: 1px solid rgba(219, 234, 254, 0.95);
}

.survey-currentstat strong {
  display: block;
  margin-top: 0.32rem;
  color: #0f172a;
  font-size: 0.95rem;
  font-weight: 800;
}

.survey-currenthead__title {
  margin: 0;
  color: #0f172a;
  font-size: 1.5rem;
  line-height: 1.38;
  font-weight: 800;
}

.survey-questionstack {
  display: grid;
  gap: 0.9rem;
  margin-top: 1rem;
}

.survey-actionbar {
  position: sticky;
  bottom: 0.9rem;
  z-index: 5;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.85rem;
  margin-top: 1rem;
  padding: 0.9rem 1rem;
  border-radius: 1.6rem;
  animation: surveyRise 0.6s ease-out both;
}

.survey-actionbar .survey-button {
  width: 100%;
}

.survey-button {
  appearance: none;
  border: 0;
  border-radius: 1.1rem;
  padding: 0.9rem 1.2rem;
  font-size: 0.95rem;
  font-weight: 800;
  line-height: 1;
  transition: transform 180ms ease, box-shadow 180ms ease, opacity 180ms ease, background 180ms ease;
}

.survey-button:hover:not(:disabled) {
  transform: translateY(-1px);
}

.survey-button:disabled {
  opacity: 0.45;
}

.survey-button--ghost {
  background: rgba(255, 255, 255, 0.9);
  color: #475569;
  border: 1px solid rgba(203, 213, 225, 0.96);
}

.survey-button--primary {
  background: linear-gradient(135deg, #5b6cfb 0%, #4f46e5 100%);
  color: #fff;
  box-shadow: 0 18px 34px rgba(79, 70, 229, 0.24);
}

.survey-button--submit {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: #fff;
  box-shadow: 0 18px 34px rgba(5, 150, 105, 0.24);
}

@media (min-width: 1080px) {
  .survey-experience__inner {
    padding-top: 1.8rem;
  }
}
@media (max-width: 767px) {
  .survey-experience__inner {
    padding: 0.75rem 0.75rem 8.2rem;
  }
  .survey-panel,
  .survey-actionbar,
  .survey-state-card {
    border-radius: 1.3rem;
  }
  .survey-state-card--verify {
    margin-top: 1.2rem;
    padding: 1.25rem 1rem;
  }
  .survey-panel {
    padding: 0.92rem;
  }
  .survey-panel__title,
  .survey-currenthead__title,
  .survey-state-card__title {
    font-size: 1.08rem;
  }
  .survey-verify {
    margin-top: 0.95rem;
    gap: 0.65rem;
  }
  .survey-verify__input,
  .survey-verify__button {
    min-height: 3.1rem;
    padding: 0.82rem 0.9rem;
    border-radius: 0.95rem;
  }
  .survey-verify__input {
    font-size: 0.92rem;
  }
  .survey-verify__button {
    font-size: 0.88rem;
  }
  .survey-panel--hero .survey-panel__desc {
    display: none;
  }
  .survey-panel--hero {
    padding: 0.85rem 0.9rem;
  }
  .survey-identity {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.7rem;
    margin-top: 0.7rem;
    padding: 0.72rem 0.82rem;
    border-radius: 1rem;
  }
  .survey-identity__label {
    font-size: 0.72rem;
  }
  .survey-identity__value {
    margin-top: 0;
    font-size: 1.08rem;
  }
  .survey-progress {
    margin-top: 0.72rem;
  }
  .survey-progress__meta span,
  .survey-progress__meta strong {
    font-size: 0.76rem;
  }
  .survey-progress__track {
    height: 0.48rem;
    margin-top: 0.38rem;
  }
  .survey-currentstats {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 0.45rem;
    margin-top: 0.8rem;
  }
  .survey-currentstat {
    padding: 0.62rem 0.65rem;
    border-radius: 0.95rem;
  }
  .survey-currentstat span {
    font-size: 0.67rem;
  }
  .survey-currentstat strong {
    margin-top: 0.18rem;
    font-size: 0.8rem;
    line-height: 1.35;
  }
  .survey-currenthead__guide {
    margin-top: 0.45rem;
    font-size: 0.82rem;
    line-height: 1.52;
  }
  .survey-questionstack {
    gap: 0.65rem;
    margin-top: 0.78rem;
  }
  .survey-actionbar {
    position: fixed;
    left: 0.75rem;
    right: 0.75rem;
    bottom: calc(env(safe-area-inset-bottom, 0px) + 0.6rem);
    z-index: 15;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.55rem;
    padding: 0.68rem;
    margin-top: 0;
    border-radius: 1.15rem;
  }
  .survey-button {
    min-height: 3.05rem;
    border-radius: 0.95rem;
    padding: 0.82rem 1rem;
    font-size: 0.9rem;
  }
}
@keyframes surveyRise {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes surveySpin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes surveyFloat {
  0%, 100% {
    transform: translateY(0) translateX(0);
  }
  50% {
    transform: translateY(12px) translateX(8px);
  }
}`],
})
export class PageSurveyTakeComponent implements OnInit, OnDestroy {
    public token: string = '';
    public loading: boolean = true;
    public saving: boolean = false;
    public submitting: boolean = false;
    public verificationRequired: boolean = false;
    public verifying: boolean = false;
    public birthInput: string = '';
    public birthError: string = '';
    public verifiedBirth: string = '';

    public subject: any = {};
    public template: any = {};
    public flow: any = {};
    public formCode: string = '';
    public schema: any = { sections: [], scales: {} };
    public answers: any = {};
    public response: any = {};
    public errorMessage: string = '';

    public sectionIdx: number = 0;
    public visibleSections: any[] = [];

    private saveTimer: any = null;
    private saveQueued: boolean = false;

    constructor(@Inject( Service) public service: Service) { }

    private payload(data: any): any {
        if (data && data.data !== undefined) {
            return data.data;
        }
        return data || {};
    }

    private statusCode(res: Response, body: any): number {
        if (body && typeof body.code === 'number') {
            return body.code;
        }
        return res.status;
    }

    private surveyApiUrl(action: string = ''): string {
        let url = '/api/survey/' + encodeURIComponent(this.token);
        if (action) {
            url += '/' + action;
        }
        if (this.verifiedBirth) {
            const sep = url.indexOf('?') >= 0 ? '&' : '?';
            url += sep + 'birth=' + encodeURIComponent(this.verifiedBirth);
        }
        return url;
    }

    private message(body: any, defaultMessage: string): string {
        if (body && body.message) {
            return body.message;
        }
        if (body && body.data && body.data.message) {
            return body.data.message;
        }
        return defaultMessage;
    }

    public async ngOnInit() {
        await this.service.init();
        this.token = WizRoute.segment.token;
        await this.load();
    }

    public ngOnDestroy() {
        if (this.saveTimer) clearTimeout(this.saveTimer);
    }

    public async load() {
        this.loading = true;
        this.errorMessage = '';
        await this.service.render();

        try {
            const res = await fetch(this.surveyApiUrl(), {
                method: 'GET',
                credentials: 'same-origin'
            });
            const body = await res.json();
            const status = this.statusCode(res, body);
            if (status !== 200) {
                this.loading = false;
                if (status === 404) {
                    location.href = '/s-invalid/not_found';
                    return;
                }
                if (status === 410) {
                    location.href = '/s-invalid/expired';
                    return;
                }
                if (status === 409) {
                    location.href = '/s/' + this.token + '/done';
                    return;
                }
                if (status === 401 && body && body.data && body.data.verification_required) {
                    this.loading = false;
                    this.verificationRequired = true;
                    this.verifiedBirth = '';
                    this.birthError = this.message(body, '생년월일 확인이 필요합니다.');
                    this.subject = {};
                    this.schema = { sections: [], scales: {} };
                    this.answers = {};
                    this.response = {};
                    this.visibleSections = [];
                    await this.service.render();
                    return;
                }
                this.errorMessage = this.message(body, '오류가 발생했습니다.');
                await this.service.render();
                return;
            }
            const payload = this.payload(body.data);
            this.verificationRequired = false;
            this.birthError = '';
            this.subject = payload.subject || {};
            this.template = payload.template || {};
            this.flow = payload.flow || {};
            this.formCode = payload.form_code || 'original_survey';
            this.schema = this.template.schema || { sections: [], scales: {} };
            this.answers = payload.answers || {};
            this.response = payload.response || {};

            this.sectionIdx = 0;
            this.buildVisibleSections();
            this.loading = false;
            if (this.visibleSections.length === 0) {
                this.errorMessage = '표시할 설문 문항이 없습니다. 관리자에게 문의해주세요.';
            }
            // 저장된 진행 섹션 복원
            const cur = this.response.current_section || '';
            if (cur) {
                const idx = this.visibleSections.findIndex((s: any) => s.key === cur);
                if (idx >= 0) this.sectionIdx = idx;
            }
            await this.service.render();
        } catch (e: any) {
            this.loading = false;
            this.errorMessage = '네트워크 오류: ' + (e && e.message ? e.message : e);
            await this.service.render();
        }
    }

    private formatBirthInput(value: any): string {
        const digits = String(value || '').replace(/[^0-9]/g, '').slice(0, 8);
        if (digits.length <= 4) return digits;
        if (digits.length <= 6) return `${digits.slice(0, 4)}-${digits.slice(4)}`;
        return `${digits.slice(0, 4)}-${digits.slice(4, 6)}-${digits.slice(6)}`;
    }

    public onBirthInput(event: any) {
        const value = (event && event.target && event.target.value) ? String(event.target.value) : '';
        this.birthInput = this.formatBirthInput(value);
    }

    public async verifyBirth() {
        const normalized = this.birthInput.replace(/[^0-9]/g, '');
        if (normalized.length !== 8) {
            this.birthError = '생년월일 8자리를 입력해주세요.';
            await this.service.render();
            return;
        }

        this.verifying = true;
        this.birthError = '';
        this.verifiedBirth = this.birthInput;
        await this.service.render();

        try {
            await this.load();
            this.verifying = false;

            if (this.verificationRequired === false) {
                this.birthInput = '';
                return;
            }
            await this.service.render();
        } catch (e: any) {
            this.verifying = false;
            this.verifiedBirth = '';
            this.birthError = '네트워크 오류: ' + (e && e.message ? e.message : e);
            await this.service.render();
        }
    }

    public buildVisibleSections() {
        const sections = (this.schema && this.schema.sections) || [];
        const gender = (this.subject && this.subject.gender) || 'O';
        this.visibleSections = sections.filter((s: any) => this.sectionVisible(s, gender));
    }

    public sectionGuide(section: any): string {
        if (!section) return '';
        return section.guide || section.desc || '';
    }

    public trackByQuestion(_index: number, question: any): string {
        return question?.key || String(_index);
    }

    public sectionVisible(section: any, gender: string): boolean {
        const show = section.showIf;
        if (!show) return true;
        if (show.subjectField === 'gender' && show.eq) {
            return gender === show.eq;
        }
        return true;
    }

    public currentSection(): any {
        return this.visibleSections[this.sectionIdx] || null;
    }

    public hasValue(value: any): boolean {
        if (value === null || value === undefined) return false;
        if (typeof value === 'string') return value.trim().length > 0;
        if (Array.isArray(value)) return value.length > 0;
        if (typeof value === 'object') {
            const values = Object.values(value);
            if (values.length === 0) return false;
            return values.some((item: any) => this.hasValue(item));
        }
        return true;
    }

    public questionCount(section: any): number {
        return this.visibleQuestions(section).length;
    }

    public answeredCount(section: any): number {
        const questions = this.visibleQuestions(section);
        let count = 0;
        for (const q of questions) {
            if (this.isQuestionAnswered(q)) {
                count++;
            }
        }
        return count;
    }

    public isQuestionAnswered(question: any): boolean {
        if (!question) return false;

        if (question.optional === true) {
            return true;
        }

        const value = this.answers[question.key];
        let answered = false;

        if (question.type === 'table_matrix') {
            if (!value || typeof value !== 'object' || Array.isArray(value)) return false;
            const rows = Array.isArray(question.rows) ? question.rows : [];
            answered = rows.every((row: any) => this.hasValue(value[row.key]));
            if (!answered) return false;
            const extraQuestions = Array.isArray(question.extraQuestions) ? question.extraQuestions : [];
            return extraQuestions.every((extra: any) => this.isQuestionAnswered(extra));
        }

        if (question.type === 'obstetric' || question.type === 'smoke_detail') {
            if (!value || typeof value !== 'object' || Array.isArray(value)) return false;
            const fields = Array.isArray(question.fields) ? question.fields : [];
            return fields.every((field: any) => this.hasValue(value[field.key]));
        }

        if (question.type === 'drink_row') {
            const requiredKeys = ['type', 'amount', 'unit', 'count'];
            if (Array.isArray(value)) {
                const rows = value.filter((row: any) => row && typeof row === 'object' && !Array.isArray(row));
                const activeRows = rows.filter((row: any) => requiredKeys.some((key: string) => this.hasValue(row[key])));
                if (activeRows.length === 0) return false;
                return activeRows.every((row: any) => requiredKeys.every((key: string) => this.hasValue(row[key])));
            }
            if (!value || typeof value !== 'object') return false;
            return requiredKeys.every((key: string) => this.hasValue(value[key]));
        }

        answered = this.hasValue(value);
        if (!answered) return false;
        const extraQuestions = Array.isArray(question.extraQuestions) ? question.extraQuestions : [];
        return extraQuestions.every((extra: any) => this.isQuestionAnswered(extra));
    }

    public scales(): any {
        return (this.schema && this.schema.scales) || {};
    }

    private questionVisibleWithAnswers(q: any, answers: any): boolean {
        const cond = q && q.showIf;
        if (!cond) return true;
        const refKey = cond.key;
        const refVal = refKey ? answers?.[refKey] : undefined;

        if (cond.notIn && Array.isArray(cond.notIn)) {
            if (refVal === null || refVal === undefined) return false;
            return cond.notIn.indexOf(refVal) < 0;
        }
        if (cond.in && Array.isArray(cond.in)) {
            if (refVal === null || refVal === undefined) return false;
            return cond.in.indexOf(refVal) >= 0;
        }
        if (cond.eq !== undefined) {
            return refVal === cond.eq;
        }
        if (cond.ne !== undefined) {
            return refVal !== cond.ne;
        }
        if (cond.gt !== undefined) {
            return typeof refVal === 'number' && refVal > cond.gt;
        }
        if (cond.gte !== undefined) {
            return typeof refVal === 'number' && refVal >= cond.gte;
        }
        if (cond.nonEmpty) {
            return this.hasValue(refVal);
        }
        return true;
    }

    private allQuestions(): any[] {
        const sections = (this.schema && this.schema.sections) || [];
        return sections.flatMap((section: any) => Array.isArray(section?.questions) ? section.questions : []);
    }

    private clearQuestionTree(questionKey: string) {
        if (!questionKey || !this.answers) return;
        this.answers[questionKey] = null;

        for (const question of this.allQuestions()) {
            if (question?.showIf?.key === questionKey) {
                this.clearQuestionTree(question.key);
            }
        }
    }

    private resetConditionalAnswers(evt: any) {
        const questionKey = evt && evt.key;
        if (!questionKey || !this.answers) return;

        const previousValue = evt.previousValue;
        const previousAnswers = {
            ...this.answers,
            [questionKey]: previousValue,
        };

        for (const question of this.allQuestions()) {
            if (question?.showIf?.key !== questionKey) continue;

            const wasVisible = this.questionVisibleWithAnswers(question, previousAnswers);
            const isVisible = this.questionVisibleWithAnswers(question, this.answers);

            if (wasVisible !== isVisible) {
                this.clearQuestionTree(question.key);
            }
        }
    }

    // 질문 노출 조건 평가
    public questionVisible(q: any): boolean {
        return this.questionVisibleWithAnswers(q, this.answers);
    }

    private embeddedQuestionKeys(parentKey: string): string[] {
        if (parentKey === 'psqi_5') {
            return ['psqi_5_j', 'psqi_5_j1'];
        }
        return [];
    }

    public visibleQuestions(section: any): any[] {
        if (!section || !section.questions) return [];
        const visible = section.questions.filter((q: any) => this.questionVisible(q));
        const hiddenKeys = new Set(['psqi_5_j', 'psqi_5_j1']);
        return visible
            .filter((q: any) => hiddenKeys.has(q.key) === false)
            .map((q: any) => {
                const embeddedKeys = this.embeddedQuestionKeys(q.key);
                if (embeddedKeys.length === 0) return q;
                const extraQuestions = visible.filter((item: any) => embeddedKeys.indexOf(item.key) >= 0);
                if (extraQuestions.length === 0) return q;
                return {
                    ...q,
                    extraQuestions,
                };
            });
    }

    public onAnswerChange(evt: any) {
        this.resetConditionalAnswers(evt);
        this.scheduleAutosave();
    }

    private scheduleAutosave() {
        if (this.saveTimer) clearTimeout(this.saveTimer);
        this.saveTimer = setTimeout(() => this.autosave(), 800);
    }

    private async autosave() {
        if (this.submitting) return;
        if (this.saving) {
            this.saveQueued = true;
            return;
        }
        const sec = this.currentSection();
        if (!sec) return;

        const body = new URLSearchParams();
        body.append('answers', JSON.stringify(this.answers));
        body.append('section', sec.key);
        body.append('progress', String(this.progressPct()));
        body.append('current_section', sec.key);
        body.append('birth', this.verifiedBirth);
        body.append('form_code', this.formCode);

        this.saving = true;
        await this.service.render();
        try {
            const res = await fetch(this.surveyApiUrl('save'), {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                credentials: 'same-origin',
                body: body.toString()
            });
            const result = await res.json();
            const status = this.statusCode(res, result);
            if (status === 401) {
                this.verificationRequired = true;
                this.verifiedBirth = '';
                this.birthError = '생년월일 확인이 다시 필요합니다.';
            }
            if (status === 409) {
                this.saving = false;
                await this.load();
                return;
            }
        } catch (e) { /* silent */ }
        this.saving = false;
        await this.service.render();
        if (this.saveQueued) {
            this.saveQueued = false;
            void this.autosave();
        }
    }

    public progressPct(): number {
        if (this.visibleSections.length === 0) return 0;
        return Math.round(((this.sectionIdx + 1) / this.visibleSections.length) * 100);
    }

    public statusText(): string {
        if (this.submitting) return '제출 준비 중';
        if (this.saving) return '자동 저장 중...';
        return '자동 저장됨';
    }

    public surveyTitle(): string {
        return this.template?.title || '한의검진 문진 및 설문';
    }

    public surveyDescription(): string {
        if (this.template?.description) return this.template.description;
        if (this.formCode === 'geriatric_depression') {
            return '지난 1주일 동안의 느낌을 생각하면서 응답해주세요.';
        }
        return '최근 상태를 떠올리며 자연스럽게 답하면 됩니다.';
    }

    public flowLabel(): string {
        const current = Number(this.flow?.current_index || 1);
        const total = Number(this.flow?.total || 2);
        return `${current}/${total} 단계`;
    }

    public submitButtonLabel(): string {
        return this.formCode === 'geriatric_depression'
            ? '최종 제출하기'
            : '다음 검사로 이동';
    }

    public submitOverlayTitle(): string {
        return this.formCode === 'geriatric_depression'
            ? '최종 응답을 안전하게 저장하고 있습니다'
            : '기본 설문을 저장하고 다음 검사를 준비하고 있습니다';
    }

    public submitConfirmMessage(): string {
        return this.formCode === 'geriatric_depression'
            ? '한국형 노인우울척도를 최종 제출하시겠습니까? 제출 후에는 직접 수정할 수 없습니다.'
            : '기본 설문을 제출하고 한국형 노인우울척도로 이동하시겠습니까?';
    }

    public async next() {
        if (!this.validateCurrent()) return;
        if (this.sectionIdx < this.visibleSections.length - 1) {
            if (this.saveTimer) clearTimeout(this.saveTimer);
            this.sectionIdx++;
            try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) {}
            await this.service.render();
            void this.autosave();
        }
    }

    public async prev() {
        if (this.sectionIdx > 0) {
            this.sectionIdx--;
            try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) {}
            await this.service.render();
        }
    }

    public validateCurrent(): boolean {
        const sec = this.currentSection();
        if (!sec) return true;
        const qs = this.visibleQuestions(sec);
        for (const q of qs) {
            if (!this.isQuestionAnswered(q)) {
                alert('현재 구분의 문항을 모두 응답해주세요: ' + (q.label || q.key));
                return false;
            }
        }
        return true;
    }

    public async submit() {
        if (!this.validateCurrent()) return;
        if (!confirm(this.submitConfirmMessage())) return;

        this.submitting = true;
        await this.service.render();
        try {
            const body = new URLSearchParams();
            body.append('answers', JSON.stringify(this.answers));
            body.append('birth', this.verifiedBirth);
            body.append('form_code', this.formCode);
            const res = await fetch(this.surveyApiUrl('submit'), {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                credentials: 'same-origin',
                body: body.toString()
            });
            const body2 = await res.json();
            const status = this.statusCode(res, body2);
            this.submitting = false;
            if (status === 200) {
                const result = this.payload(body2.data);
                if (result.complete === true) {
                    location.href = '/s/' + this.token + '/done';
                    return;
                }
                this.sectionIdx = 0;
                await this.load();
                try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) {}
            } else if (status === 409) {
                await this.load();
            } else {
                alert(this.message(body2, '제출 실패'));
                await this.service.render();
            }
        } catch (e: any) {
            this.submitting = false;
            alert('네트워크 오류: ' + (e && e.message ? e.message : e));
            await this.service.render();
        }
    }

    public isLastSection(): boolean {
        return this.sectionIdx >= this.visibleSections.length - 1;
    }
}

export default PageSurveyTakeComponent;